import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DTypeFormChipListField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { debounceTime, map, Observable, of, Subject, switchMap, takeUntil } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { CompanyService } from '../../../company/company.service';
import { UserService } from '../../../user/user.service';

@Component({
    selector: 'user-profile-chiplist-field',
    templateUrl: 'user-profile-chiplist-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeUserProfileChiplistFieldComponent implements DTypeFormFieldComponent, OnInit, OnDestroy {

    @Input() field: DTypeFormChipListField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    searchCtrl = new FormControl();
    options$: Observable<any[]>;

    private _unsubscribeAll = new Subject<void>();

    constructor(
        private companyService: CompanyService,
        private usersService: UserService,
    ) { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }

        // TODO process when field.control is enabled/disabled
        if (this.field.control.disabled) {
            this.searchCtrl.disable();
        }

        this.options$ = this.searchCtrl.valueChanges.pipe(
            takeUntil(this._unsubscribeAll),
            debounceTime(1000),
            switchMap((value) => {
                if (typeof value === 'string' && value.length >= 3) {
                    return this.usersService.searchCompanyUser(value, this.companyService.structureCompanyId).pipe(
                        map(users => users.map((user) => {
                            const option: any = user;
                            option.caption = user.displayName;
                            return option;
                        }))
                    );
                }
                return of([]);
            })
        );
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
